const dataHooks = [
  {
    title: "useOnClickOutside Hook",
    shortDescription:
      "The 'Click Away' detector. It closes a menu or modal when you click anywhere else on the screen.",
    description:
      "Have you ever opened a dropdown menu and expected it to close just by clicking the background? That behavior isn't automatic; developers have to build it! This hook acts like a security guard. It listens to every click on the page and asks a simple question: *'Did this click happen INSIDE my content box?'* If the answer is **No** (meaning you clicked outside), it automatically triggers the 'Close' function. It makes your app feel polished and intuitive.",
  },
];

export default dataHooks;